var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlovoLogoLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 679,
    height: 679,
    viewBox: "0 0 679 679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fec233;}.cls-2{fill:#00a081;}.cls-3{fill:#02a181;}.cls-4{fill:#fec429;}.cls-5{fill:#fec42b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "glovo-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.87,35.87q331.59,0,663.19-.37c12.91,0,15.47,2.53,15.44,15.44q-.76,324.06,0,648.12c0,12.9-2.53,15.47-15.44,15.44q-324.06-.76-648.12,0c-12.9,0-15.47-2.53-15.44-15.44Q36.27,367.47,35.87,35.87Z",
    transform: "translate(-35.5 -35.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.84,189.4c100.41-.22,157.63,95.91,112.08,173.44-21.11,36-46.81,69.29-71.66,102.91-12,16.29-48.29,15.33-60.27-1-23.59-32.18-47.7-64.14-68.82-97.93-23.67-37.87-24.25-78.31-2.45-117.72C293.63,209.47,328.57,190.79,362.84,189.4Z",
    transform: "translate(-35.5 -35.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.9,560.61c-18.5-.34-32.5-14.48-31.9-32.21s15.24-31,33.77-30.33c18.06.67,30.76,13.59,30.76,31.3C405.53,547.67,391.65,561,372.9,560.61Z",
    transform: "translate(-35.5 -35.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.24,294.57v21.84C248.06,308.73,252.22,301.55,253.24,294.57Z",
    transform: "translate(-35.5 -35.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.42,185.67c8.13-3.63,12.72-3.09,17.86-1.84C375.87,188.81,371,185.81,362.42,185.67Z",
    transform: "translate(-35.5 -35.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.94,495.57c-1.76-.72-4.42-.17-3.28-2.61.41-.87,3.2-.89,4.87-.8,1,0,1.86,1.1,2.78,1.71Z",
    transform: "translate(-35.5 -35.5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.87,245.45c46.11.3,75.1,50.91,50.88,90.42-13.39,21.86-29.44,42.09-44.11,63.18-5,7.2-9,7.3-14-.16-15.12-22.29-32.39-43.32-45.58-66.68C299.14,293.44,329.37,245.17,373.87,245.45Z",
    transform: "translate(-35.5 -35.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlovoLogoLocation);
export default __webpack_public_path__ + "static/media/glovo-logo-location.bcc96979ce1448a1a5dea2652f5a3066.svg";
export { ForwardRef as ReactComponent };